import {ReactElement} from "react";
import {styles} from "./styles/RightPanelHorizontalDivider.style";


const RightPanelHorizontalDivider = ({

}): ReactElement => (
    <div style={styles.RightPanelHorizontalDivider}></div>
);

export default RightPanelHorizontalDivider;